import type { ContentProps } from '@workspace/core-ts/types';

export default {
    title: {
        site: 'Vos informations',
        courtier: 'Informations de votre client',
    },
    labelEmail: {
        site: 'Adresse e-mail',
        courtier: 'Adresse e-mail de votre client',
    },
    labelConfirmEmail: {
        site: "Confirmer l'adresse e-mail",
        courtier: "Confirmer l'adresse e-mail de votre client",
    },
    labelTel: {
        site: 'Numéro de téléphone',
        courtier: 'Numéro de téléphone de votre client',
    },
    descriptionTel: {
        site: 'Il sera utilisé dans le cadre de la gestion de votre contrat',
        courtier: 'Il sera utilisé dans le cadre de la gestion de son contrat',
    },
} as unknown as ContentProps;
